import { ActionTypes } from "../action-type";

const initialState = {
    debate:{},
    extra_details:{},
    debate_type:null,
}

export const debateDetailsReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.DEBATE_DETAILS:
            return {...state,debate:action.payload.debate,
            extra_details:action.payload.details,
            }
        default:
            return state;


    }
}